import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PageLoader } from './shared/components/page-loader/page-loader';
import { ToastHost } from './shared/components/toast-host/toast-host';
import { ConfirmHost } from './shared/components/confirm-host/confirm-host';
import { AuthService } from './core/services/auth.service';
import { RealtimeService } from './core/services/realtime.service';

@Component({
  selector: 'hntr-root',
  imports: [RouterOutlet, PageLoader, ToastHost, ConfirmHost],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.html',
})
export class App {
  private readonly auth = inject(AuthService);
  private readonly realtime = inject(RealtimeService);

  constructor() {
    // ALRT-01/03: only connect to the events hub while an operator is signed in.
    effect(() => {
      if (this.auth.isAuthenticated()) this.realtime.start();
      else this.realtime.stop();
    });
  }
}
